export * from '@primeuix/themes/nora/inlinemessage';
export { default } from '@primeuix/themes/nora/inlinemessage';
